module.exports = __webpack_public_path__ + "static/assets/937814f79522ddaecdc306375c7330af.png";